import {
  USER,
  SET_USER,
  ADD_ALERT,
  INIT_STATE,
  RELEASE_STATE,
  REMOVE_ALERT,
  ALERT_SUCCESS,
  ALERT_INFO,
  ALERT_WARNING,
  ALERT_DANGER,
  ALERT_AUTO_DISMISS
} from './definition'

import { preInit } from 'src/components/common/store/definition'

import sourcingWorkflow from 'src/components/sourcing_workflow/store'
import sourcingWorkflow2 from 'src/components/sourcing-workflow/store'
import commonStore from 'src/components/common/store/index'
import qasStore from 'src/components/qas/common/store/index'
import samplemanagementStore from 'src/components/samplemanagement/common/store/index'
import bookingStore from 'src/components/booking/store'

import { axios } from 'src/plugins/axios'
import qs from 'qs'

import { modules } from './index'

const auth = params => {
  return axios.post('/oauth/token', qs.stringify(params), {
    auth: {
      username: 'smee-web',
      password: 'smee-web-secret'
    },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

const invalidCredentialsError = message => ({
  name: 'invalid_credentials',
  message
})

const retrieveAccessToken = ({ getters, commit }, credentials) => {
  let userName = null
  let password = null
  let refreshToken = null
  if (credentials) {
    ({ userName, password, refreshToken } = credentials)
  }
  if ((!userName || !password) && !refreshToken) {
    refreshToken = getters.user.refreshToken
    if (!refreshToken) {
      throw invalidCredentialsError('Cannot find any user name, password or refresh token.')
    }
  }
  let params = refreshToken ? {
    'grant_type': 'refresh_token',
    'refresh_token': refreshToken
  } : {
    'grant_type': 'password',
    username: userName,
    password,
    scope: 'write'
  }
  return auth(params).then(response => {
    const data = response.data
    commit('tokens', {
      accessToken: data['access_token'],
      refreshToken: data['refresh_token'],
      tokenType: data['token_type']
    })
  })
}

const requestConfig = ({ api, method, data, getters }) => {
  if (!method) {
    method = 'GET'
  }
  const config = {
    url: api,
    method,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer' + ' ' + getters[USER].token
    }
  }
  if (data) {
    config[(method.toLowerCase() === 'get' ? 'params' : 'data')] = data
  }
  return config
}

const isAccessTokenExpired = error => {
  if (error && error.response && error.response.data) {
    const responseData = error.response.data
    if (responseData.error === 'invalid_token') {
      return responseData['error_description'] && responseData['error_description'].startsWith('Access token expired')
    }
  }
  return false
}

const request = async ({ getters, commit, dispatch }, { api, method, data }) => {
  let { error = null, response = null } = await axios.request(requestConfig({ api, method, data, getters })).then(response => ({ response })).catch(error => ({ error }))
  if (isAccessTokenExpired(error)) {
    // error = await dispatch('retrieveAccessToken').catch(error => error)
  }
  if (!error && !response) {
    response = axios.request(requestConfig({ api, method, data, getters }))
  }
  if (!response) {
    throw error
  }
  return response
}

export default {
  request,
  retrieveAccessToken,
  [INIT_STATE] ({ dispatch, commit }, { user, store }) {
    commit(SET_USER, user)
    store.registerModule('sourcingWorkflow', sourcingWorkflow)
    store.registerModule('sourcingWorkflow2', sourcingWorkflow2)
    store.registerModule('common', commonStore)
    store.registerModule('qas', qasStore)
    store.registerModule('samplemanagement', samplemanagementStore)
    store.registerModule('bookingStore', bookingStore)
    return dispatch(preInit)
  },
  [RELEASE_STATE] ({ commit, getters }, { store }) {
    if (getters[USER] !== null) {
      commit(SET_USER, null)
      store.unregisterModule('sourcingWorkflow')
      store.unregisterModule('sourcingWorkflow2')
      store.unregisterModule('common')
      store.unregisterModule('qas')
      store.unregisterModule('samplemanagement')
      store.unregisterModule('bookingStore')
      modules.forEach(module => {
        store.unregisterModule(module)
      })
    }
  },
  [ALERT_SUCCESS] ({ dispatch }, { message }) {
    dispatch(ALERT_AUTO_DISMISS, {
      message,
      css: 'alert-success'
    })
  },
  [ALERT_INFO] ({ dispatch }, { message }) {
    dispatch(ALERT_AUTO_DISMISS, {
      message,
      css: 'alert-info'
    })
  },
  [ALERT_WARNING] ({ dispatch }, { message }) {
    dispatch(ALERT_AUTO_DISMISS, {
      message,
      css: 'alert-warning'
    })
  },
  [ALERT_DANGER] ({ dispatch }, { message }) {
    dispatch(ALERT_AUTO_DISMISS, {
      message,
      css: 'alert-danger'
    })
  },
  [ALERT_AUTO_DISMISS] ({ commit }, alert) {
    commit(ADD_ALERT, alert)
    setTimeout(() => {
      commit(REMOVE_ALERT, alert)
    }, 6000)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js